import React, {Component} from "react";
import DetailView from "./DetailView";
import {Growl} from "primereact/growl";
import {CorporateActionService} from "../../../service/admin/corporateAction/CorporateActionService";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Menu} from 'primereact/menu';
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import {Builder} from "../../../utils/lists/ListProcessor";

export default class DetailContainer extends Component {
    /**
     * Constructor de la clase SplitContainer
     * en este se inicializan los valores iniciales de la clase.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     */
    constructor(props) {
        super(props);

        this.corporateActionService = new CorporateActionService();
        this.getDataLoanCorporateAction = this.getDataLoanCorporateAction.bind(this);
        this.exportAction = this.exportAction.bind(this);
        this.loading = this.loading.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            loanDetail: this.getDataLoanCorporateAction(),
            isLoading: true,
            expanded: false,
            listInstitutions: [],
            mapInstitutions: [],
            items: [
                {
                    label: 'Excel',
                    command: () => {
                        this.exportAction()
                    }
                },
            ]
        };
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }


    /**
     * Función que regresa a la pantalla de CorporateAction
     */
    returnCorporateActionPage = () => {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    /**
     * Función que obtiene el detalle que ese muestra en la patanlla de
     * ejercicios de derecho, haciendo la petición al service CorporateActionService.
     * @returns Detalle de los ejercicios.
     */
    getDataLoanCorporateAction() {
        this.loading();
        return this.corporateActionService.getLoanCorporateAction()
            .then((loanDetail) => {
                let builder = new Builder();
                builder.groupList(loanDetail, 'nomCorto');
                this.setState({
                    mapInstitutions: builder.mapObjects,
                    isLoading: false,
                });
            });
    }

    /**
     * Función que se encarga de contraer y expandir los grupos de
     * instituciones en el dataTable
     */
    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.mapInstitutions,
                expanded: true,
            });
        }
    }

    /**
     * Función para expandir o contraer una de las filas de la tabla
     * @param event Variable donde vienen los elementos que se
     *          van a expandir.
     */
    handleToggle = (event) => {
        this.setState({expandedRows: event.data,});
    }

    /**
     * Función que realiza un template de lo que va a poner
     * en cada uno de los agrupamientos de la tabla.
     * @param data Es una de las instituciones ya ordenadas con sus
     *              elementos
     * @returns {*} Un código del template
     */
    rowExpansionTemplate(data) {
        let itemsAccount = data.items;
        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    value={itemsAccount}
                    responsive={true}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>

                    <Column field="corporateAction" header="Ejercicio de Derecho"
                            style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="tipo" header="Tipo"
                            style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="idFolioPrest" header="Folio"
                            style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="fullInstrument" header="Emisora"
                            style={{textAlign: 'left'}} sortable={true}/>
                    <Column field="fullInstrumentOld" header="Emisora anterior"
                            style={{textAlign: 'right'}} sortable={true}/>
                    <Column field="cantidad" header="Títulos"
                            style={{textAlign: 'left'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="cantidadOld" header="CantidadAnterior"
                            style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                </DataTable>
            </div>
        );
    }

    /**
     * Función que exporta lo que se encuentra en la tabla a un documento de
     * excel. Para ello, hace una petición al back por medio de
     * CorporateActionService.
     */
    exportAction() {
        this.loading();
        this.corporateActionService.exportDetailCorporateAction()
            .then(response => {
                    this.setState({
                        isLoading: false
                    });
                }
            );
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let exportMenu =
            <div>
                <Button label="Contraer / Expandir Grupos" className="p-button-secondary"
                        onClick={this.expandReduceAll}
                />
                &nbsp;
                <Menu model={this.state.items} popup={true} ref={el => this.menu = el} style={{textAlign: 'left'}}/>
                <Button label="Exportar" className="p-button-secondary"
                        icon="pi pi-angle-down" iconPos="right"
                        onClick={(event) => this.menu.toggle(event)}/>
            </div>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {isLoading, expandedRows, mapInstitutions} = this.state;

        return <DetailView messagesGrowl={messagesGrowl}
                           isLoading={isLoading}
                           expandedRows={expandedRows}
                           exportMenu={exportMenu}
                           mapInstitutions={mapInstitutions}
                           returnCorporateActionPage={this.returnCorporateActionPage}
                           rowExpansionTemplate={this.rowExpansionTemplate}
                           handleToggle={this.handleToggle}
                           getDataLoanCorporateAction={this.getDataLoanCorporateAction}
        />

    }
};